const inviteCreateUser = {
  toastr: 'Cuenta creada',
  toastr1: 'La cuenta fue creada con éxito'
};

export default inviteCreateUser;
